/**
 * @type {Readonly<{
 *     MINIMUM_SEARCH_QUERY_LENGTH: number;
 *     RESULTS_PER_PAGE: number;
 *     SEARCH_WAIT_TIMEOUT: number;
 *     COLOR_WAVELENGTH_SORT_ORDER: string[];
 *     COLOR_CSS_CLASS_MAP: Object<String, String>;
 *     FACET_ICON_ID_MAP: Object<String, String>;
 * }>}
 */
export const SEARCH = Object.freeze({
    RESULTS_PER_PAGE: 25,
    MINIMUM_SEARCH_QUERY_LENGTH: 1,
    SEARCH_WAIT_TIMEOUT: 200,
    NEWS_YEAR_ARCHIVE: 'archive',
    COLOR_WAVELENGTH_SORT_ORDER: [
        'White',
        'Multicolor',
        'IR Broadband',
        'Purple',
        'Ultraviolet (100-380 nm)',
        'Violet (380-440 nm)',
        'Deep Blue (439-461 nm)',
        'Blue (450-480 nm)',
        'Cyan (482-492 nm)',
        'Verde (495-512 nm)',
        'True Green (513-545 nm)',
        'Pure Green (554-566 nm)',
        'Green (565-575 nm)',
        'Yellow (580-595 nm)',
        'Orange (600-609 nm)',
        'Amber (609-624 nm)',
        'Red (612-630 nm)',
        'Super Red (627-639 nm)',
        'Hyper Red (635-666 nm)',
        'Far Red (720-740 nm)',
        'Infrared (<800 nm)',
        'Infrared (800-900 nm)',
        'Infrared (>800 nm)',
        'Infrared (>900 nm)',
    ],
    COLOR_CSS_CLASS_MAP: {
        white: 'is-white',
        purple: 'is-purple',
        multicolor: 'is-multicolor',
        'ultraviolet-100-380-nm': 'is-ultraviolet',
        'violet-380-440-nm': 'is-violet',
        'deep-blue-439-461-nm': 'is-deep-blue',
        'blue-450-480-nm': 'is-blue',
        'cyan-482-492-nm': 'is-cyan',
        'verde-495-512-nm': 'is-verde',
        'true-green-513-545-nm': 'is-true-green',
        'pure-green-554-566-nm': 'is-pure-green',
        'green-565-575-nm': 'is-green',
        'yellow-580-595-nm': 'is-yellow',
        'orange-600-609-nm': 'is-orange',
        'amber-609-624-nm': 'is-amber',
        'red-612-630-nm': 'is-red',
        'super-red-627-639-nm': 'is-super-red',
        'hyper-red-635-666-nm': 'is-hyper-red',
        'far-red-720-740-nm': 'is-far-red',
        'infrared-800-nm': 'is-infra-red',
        'infrared-900-nm': 'is-infra-red',
        'infrared-800-900-nm': 'is-infra-red',
        'ir-broadband': 'is-infra-red',
    },
    FACET_ICON_ID_MAP: {
        'automotive-mobility': '146405',
        computing: '146408',
        industrial: '146407',
        lighting: 'asset_eps_23206927',
        'medical-health': '146403',
        'mobile-wearables': '146411',
    },
});
